import React, { useState } from "react";
import { useUpdateEffect } from "usehooks-ts";

import normalizeOptions from "../form/normalizeOptions.js";

import InlineList from "./InlineList.jsx";
import ToggleButton from "./ToggleButton.jsx";
import useUniqueId from "./useUniqueId";

function toggleItem(array, item, force) {
  if (array.includes(item) && force !== true) {
    if (force !== true) {
      return array.filter((i) => i !== item);
    }
  } else if (force !== false) {
    return [...array, item];
  }
  return array;
}

export default function ToggleButtonGroup({
  type,
  id,
  multiple = false,
  name,
  options,
  value,
  defaultValue,
  onChange,
  buttonProps,
  ...restProps
}) {
  let isControlled = value !== undefined;

  useUpdateEffect(() => {
    // eslint-disable-next-line no-console
    console.warn(
      `ToggleButtonGroup changed from ${
        isControlled ? "uncontrolled" : "controlled"
      } to ${isControlled ? "controlled" : "uncontrolled"}`,
      value,
    );
  }, [isControlled]);

  useUpdateEffect(() => {
    if (isControlled) {
      setInternalValue(value);
    }
  }, [isControlled, value]);

  let [internalValue, setInternalValue] = useState(
    isControlled ? value : defaultValue,
  );

  let normalizedOptions = normalizeOptions(options);

  id = useUniqueId(id, "toggle-button-group");

  return (
    <InlineList role="group" id={id} {...restProps}>
      {normalizedOptions.map((option, index) => {
        return (
          <ToggleButton
            key={option.value}
            name={name}
            id={`${id}-${index}`}
            type={type ?? (multiple ? "checkbox" : "radio")}
            checked={
              internalValue === undefined
                ? internalValue
                : multiple
                ? internalValue.includes(option.value)
                : option.value === internalValue
            }
            onChange={(event) => {
              let newValue = multiple
                ? toggleItem(internalValue, option.value, event.target.checked)
                : event.target.checked
                ? option.value
                : null;
              if (!isControlled) {
                setInternalValue(newValue);
              }
              if (onChange) {
                onChange(
                  { target: { value: newValue, name }, originalEvent: event },
                  newValue,
                );
              }
            }}
            buttonProps={{ ...buttonProps }}
            {...option}
          />
        );
      })}
    </InlineList>
  );
}
